import * as React from 'react';
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { FlexRowCenterVertical, TextP } from '../../..';
import { IconType, DsiSvgIcon as SvgIcon } from '../General/SvgIcon';

interface Props {
  isPasswordVisible: boolean;
  onClick: () => void;
}

function PasswordEye(props: Props) {
  return (
    <>
      {props.isPasswordVisible ? (
        <SvgIcon icon={IconType.eyeSlash} onClick={props.onClick} />
      ) : (
        <SvgIcon icon={IconType.eye} onClick={props.onClick} />
      )}
    </>
  );
}

export { PasswordEye as DsiPasswordEye };
